import type { NodeIssue } from '../../lib/nodeValidation';

interface Props {
  issues?: NodeIssue[];
}

/**
 * Tiny amber warning badge on the corner of a node when validation issues exist.
 * Hovering reveals the list of issues in a tooltip.
 */
export function NodeIssueBadge({ issues }: Props) {
  if (!issues || issues.length === 0) return null;
  const label = issues.length;
  return (
    <>
      <span
        className="vnode-issue-badge"
        title={issues.map(i => i.message).join(' · ')}
        tabIndex={0}
        aria-label={`${issues.length} validation issue${issues.length === 1 ? '' : 's'}`}
      >
        !
        {issues.length > 1 && <sup style={{ fontSize: 8, marginLeft: 1 }}>{label}</sup>}
      </span>
      <span className="vnode-issue-tooltip">
        {issues.map((i, idx) => (
          <div key={idx}>{i.message}</div>
        ))}
      </span>
    </>
  );
}
